/* eslint-disable react-hooks/exhaustive-deps */
import { getMarketplacePackages, getLocalMarketplacePackages } from 'apiCalls/PackageRequests'
import axios from 'axios'
import { SpinLoader } from 'components/Loader/SpinLoader'
import PoweredByFocalFooter from 'components/footers/PoweredByFocalFooter'
import MarketplaceCard from 'components/public/marketplace/MarketplaceCard'
import { useAppContext } from 'context/AppContext'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

function RecommendedPackages(props) {
  const [recommendedPackages, setRecommendedPackages] = useState(null)
  const source = axios.CancelToken.source()
  const [loading, setLoading] = useState(true)
  const [seed] = useState(Math.floor(Math.random() * 10000))
  const [, dispatch] = useAppContext()

  useEffect(() => {
    getLocalMarketplacePackages(
      {
        size: 4,
        limit: 4,
        seed: seed,
        priority_tag: props.activeTag,
        latitude: props.pack.location.latitude,
        longitude: props.pack.location.longitude,
      },
      source,
    ).then((response) => {
      if (response.status === 200) {
        if (response.data.results.length > 3) {
          setLoading(false)
          setRecommendedPackages(response.data.results)
        } else {
          getMarketplacePackages(
            {
              latitude: props.pack.location.latitude,
              longitude: props.pack.location.longitude,
              priority_tag: props.activeTag,
              size: 4,
            },
            source,
          ).then((response1) => {
            if (response1.status === 200) {
              setRecommendedPackages(
                [...response.data.results, ...response1.data.results]
                  .filter((item) => item.identifier !== props.pack.identifier)
                  .slice(0, 4),
              )

              setLoading(false)
            } else {
              dispatch({
                type: 'setAlertType',
                alertType: 'error',
              })
              dispatch({
                type: 'setAlertText',
                alertText: [
                  'We are currently undergoing unscheduled maintenance, we will be back up soon. Thank you for your patience',
                ],
              })
              throw new Error(response.data)
            }
          })
        }
      } else {
        dispatch({
          type: 'setAlertType',
          alertType: 'error',
        })
        dispatch({
          type: 'setAlertText',
          alertText: [
            'We are currently undergoing unscheduled maintenance, we will be back up soon. Thank you for your patience',
          ],
        })
        throw new Error(response.data)
      }
    })
  }, [props.activeTag])

  return loading ? (
    <div>
      {' '}
      <SpinLoader />
    </div>
  ) : (
    <OuterContainer>
      <Row3>
        <H8>Other Recommended Packages</H8>
        <Grid>
          {recommendedPackages &&
            recommendedPackages.map((item, index) => {
              return (
                <GridCell key={index}>
                  <MarketplaceCard
                    history={props.history}
                    items={item.images}
                    package={item}
                    recommended={true}
                  />
                </GridCell>
              )
            })}
        </Grid>
        <FooterWrap>
          <PoweredByFocalFooter photographer={props.pack.photographer} />
        </FooterWrap>
      </Row3>
    </OuterContainer>
  )
}

export default RecommendedPackages

const OuterContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--black);
`

const H8 = styled.h1`
  font-size: 22px;
  color: var(--black);
  line-height: 1.5;
  @media (max-width: 700px) {
    font-size: 18px;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 49% 49%;
  grid-column-gap: 2%;
  grid-row-gap: 1.5em;
  width: 100%;
  padding: 0 2vw;
  @media (max-width: 1250px) {
    grid-template-columns: 100%;
    width: 650px;
  }
  @media (max-width: 700px) {
    padding: 0;
    width: auto;
  }
`

const GridCell = styled.div`
  position: relative;
  border: 1px solid rgb(236, 239, 241);
  font-size: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5em;
  background: white;
  @media (max-width: 700px) {
    align-items: center;
    width: auto;
    padding: 1em;
  }
  @media (max-width: 600px) {
    font-size: 7px;
  }
`

const Row3 = styled.div`
  padding: 2em 0 1em 0;
  margin: 2em 0 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fafafa;
`
const FooterWrap = styled.div`
  font-size: 0.65em;
`
